export default function () {
  this.doLoadItem()
}



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/next-patient/resources/mounted.js